module.exports = __webpack_public_path__ + "public/Icons/manual_bookings.svg?ff142e41";